import { Component, OnInit, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  templateUrl: './information-popin.component.html',
  styleUrls: ['./information-popin.component.scss']
})
export class NeqInformationPopinComponent implements OnInit {

  message: string;

  constructor(
    private readonly dialogRef: MatDialogRef<NeqInformationPopinComponent>,
    private readonly translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: { message: string, params: Object }
  ) {}

  ngOnInit() {
    if (this.data?.message) {
      this.message = this.translate.instant(this.data.message, this.data.params)
    }
  }

  continue() {
    this.dialogRef.close();
  }
}
